module.exports = __webpack_public_path__ + "img/KG.6ccb1201.png";